export interface ITableModel {
    columns: any[]
    rows: any[]
    rowCount: number
    page: number
    pageSize: number
    loading: boolean
    pagination: boolean
    status: string
    filterText: string | null
    hiddenColumns: any
    settings: ITableSettings
  }
  
  export const DefaultTableSettings: ITableSettings = {
    breadcrumb: '',
    title: '',
    showCount: false,
    showButton: false,
    buttonText: '',
    buttonLink: '',
    hideComponents: false,
    updatePageState: () => {}
  }
  
  export const DefaultTableModel: ITableModel = {
    columns: [],
    rows: [],
    rowCount: 0,
    page: 0,
    pageSize: 10,
    loading: false,
    pagination: true,
    status: 'received',
    filterText: null,
    hiddenColumns: {},
    settings: DefaultTableSettings,
  }
  
  export interface ITableSettings {
    title: string
    breadcrumb: string
    showCount: boolean
    showButton: boolean
    buttonText: string
    buttonLink: string
    hideComponents: boolean
    updatePageState: (prop: string, value: any) => void
  }